import React from 'react'
import PropTypes from 'prop-types'

import { ChatSidebar } from './chatSidebar'
import { Messages } from './messages'
import { useGetMutateCall } from '../../lib/api/get'
import { useGetQuery } from '../../lib/api/get'

export const ChatHome = ({ envData, isLocalEnvironment, authDetails }) => {
  const getCallMutation = useGetMutateCall()
  const [myChats, setMyChats] = React.useState(null)
  const [activeChat, setActiveChat] = React.useState(null)
  const [activeChatData, setActiveChatData] = React.useState(null)
  const [contentWidth, setContentWidth] = React.useState(0)

  const activateChatFunc = async (obj, isGroupChat = false) => {
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'chatMessages',
        params: `&chatId=${obj.chatId}`,
        isDynamic: true,
        doPolling: true,
      })
      .then((resp) => {
        setActiveChatData({
          formData: resp.formData.data ? resp.formData.data : resp.formData,
          isGroupChat,
        })
        var refreshInt
        clearTimeout(refreshInt)
        refreshInt = setInterval(() => activateChatFunc(obj, isGroupChat), 120000)
      })
    setActiveChat(obj)
  }
  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'chats',
    isDynamic: true,
  })

  const getChatData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'chats/staff',
    isDynamic: true,
    enabled:
      authDetails.role === 'Staff' ||
      authDetails.role === 'Office Staff' ||
      authDetails.role === 'Staff Admin' ||
      authDetails.orgRole === 'Staff' ||
      authDetails.orgRole === 'Office Staff' ||
      authDetails.orgRole === 'Staff Admin'
        ? true
        : false,
  })

  React.useEffect(() => {
    const width = document.getElementById('chat-appwind').getBoundingClientRect().width
    setContentWidth(width)
  }, [contentWidth])

  return (
    <>
      {getData.isLoading || getChatData.isLoading ? (
        <div
          id="chat-appwind"
          className="trtui-chat-wrapper trtui-d-lg-flex gap-1 trtui-mx-n4 trtui-mt-n4 trtui-p-1"
        >
          <div>Loading</div>
        </div>
      ) : (
        <div
          id="chat-appwind"
          className="trtui-chat-wrapper trtui-d-lg-flex trtui-gap-1 trtui-mx-n4 trtui-mt-n4 trtui-p-1"
        >
          <ChatSidebar
            key={`${contentWidth}${activeChat}`}
            contWidth={contentWidth}
            isLocalEnvironment={isLocalEnvironment}
            myChats={myChats}
            activateChatFunc={activateChatFunc}
            setActiveChat={setActiveChat}
            activeChat={activeChat}
            setMyChats={setMyChats}
            authDetails={authDetails}
            envData={envData}
            getData={getData}
            getChatData={getChatData}
          />
          <Messages
            key={`${activeChat}${contentWidth}${activeChatData}`}
            contWidth={contentWidth}
            setActiveChat={setActiveChat}
            setActiveChatData={setActiveChatData}
            authDetails={authDetails}
            isLocalEnvironment={isLocalEnvironment}
            envData={envData}
            activeChat={activeChat}
            activeChatData={activeChatData}
            myChats={getData}
          />
        </div>
      )}
    </>
  )
}

ChatHome.propTypes = {
  envData: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  authDetails: PropTypes.object,
}
